import React, { useState, useEffect } from 'react';
import './Services.css';

// Importando as imagens
import programmingImage from '../../assets/images/vetores/Programming-amico.png'; 
import integrationImage from '../../assets/images/vetores/Software integration-rafiki.png';
import dashboardImage from '../../assets/images/vetores/Data extraction-amico.png'; 
import automationImage from '../../assets/images/vetores/Software integration-bro.png'; 
import landingPageImage from '../../assets/images/vetores/Website Creator-bro.png';

interface Service {
  id: number;
  title: string;
  shortDesc: string;
  description: string;
  longDescription: string;
  whyYouNeed: string;
  image: string;
  icon: JSX.Element;
  color: string;
  accentColor: string;
  features: string[];
  duration: string;
  category: string;
}

const Services: React.FC = () => {
  const [selectedService, setSelectedService] = useState<Service | null>(null);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });

  // Ícones SVG
  const Icons = {
    Code: () => (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full">
        <path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0L19.2 12l-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"/>
      </svg>
    ),
    Link: () => (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full">
        <path d="M17 7h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5zm-6 8H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-2z"/>
        <path d="M8 11h8v2H8z"/>
      </svg>
    ),
    Bullhorn: () => (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
      </svg>
    ),
    ChartBar: () => (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full">
        <path d="M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z"/>
      </svg>
    ),
    Cogs: () => (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full">
        <path d="M12 15.5A3.5 3.5 0 0 1 8.5 12A3.5 3.5 0 0 1 12 8.5a3.5 3.5 0 0 1 3.5 3.5 3.5 3.5 0 0 1-3.5 3.5m7.43-2.53c.04-.32.07-.64.07-.97 0-.33-.03-.66-.07-1l2.11-1.63c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.31-.61-.22l-2.49 1c-.52-.39-1.06-.73-1.69-.98l-.37-2.65A.506.506 0 0 0 14 2h-4c-.25 0-.46.18-.5.42l-.37 2.65c-.63.25-1.17.59-1.69.98l-2.49-1c-.22-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64L4.57 11c-.04.34-.07.67-.07 1 0 .33.03.65.07.97l-2.11 1.66c-.19.15-.25.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1.01c.52.4 1.06.74 1.69.99l.37 2.65c.04.24.25.42.5.42h4c.25 0 .46-.18.5-.42l.37-2.65c.63-.26 1.17-.59 1.69-.99l2.49 1.01c.22.08.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.66Z"/>
      </svg>
    ),
    FileAlt: () => (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full">
        <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11z"/>
      </svg>
    ),
    Play: () => (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full">
        <path d="M8 5v14l11-7z"/>
      </svg>
    ),
    Info: () => (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
      </svg>
    ),
    Mobile: () => (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full">
        <path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14zm-5-2c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"/>
      </svg>
    ),
    ChevronLeft: () => (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full">
        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
      </svg>
    ),
    ChevronRight: () => (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full">
        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
      </svg>
    )
  };

  // Dados dos serviços
  const servicesData: Service[] = [
    {
      id: 1,
      title: 'Desenvolvimento de Software',
      shortDesc: 'Soluções personalizadas para seu negócio',
      description: 'Desenvolvemos soluções completas de software sob medida.',
      longDescription: 'Desenvolvemos soluções completas de software sob medida, desde sistemas de gestão até aplicações web e mobile que otimizam e facilitam os processos do seu negócio.',
      whyYouNeed: 'Você precisa de soluções que otimizem e facilitem os processos do seu negócio.',
      image: programmingImage,
      icon: <Icons.Code />,
      color: 'from-purple-600 via-blue-600 to-indigo-700',
      accentColor: '#512BB5',
      features: ['Sistemas Web', 'Apps Mobile', 'APIs', 'Integração'],
      duration: '3-6 meses',
      category: 'Desenvolvimento'
    },
    {
      id: 2,
      title: 'Integração de Sistemas',
      shortDesc: 'Conecte suas plataformas de forma eficiente',
      description: 'Integramos sistemas para uma comunicação eficiente.',
      longDescription: 'Integramos sistemas para uma comunicação eficiente e segura entre suas plataformas, evitando retrabalho e otimizando a eficiência de suas operações.',
      whyYouNeed: 'Para evitar retrabalho e otimizar a eficiência de suas operações.',
      image: integrationImage,
      icon: <Icons.Link />,
      color: 'from-blue-600 via-cyan-600 to-teal-700',
      accentColor: '#00AEFF',
      features: ['APIs RESTful', 'Webhooks', 'Sincronização', 'Automação'],
      duration: '2-4 semanas',
      category: 'Integração'
    },
    {
      id: 3,
      title: 'Desenvolvimento Mobile',
      shortDesc: 'Apps nativos para iOS e Android',
      description: 'Desenvolvemos aplicativos mobile de alta performance.',
      longDescription: 'Desenvolvemos aplicativos mobile nativos e híbridos para iOS e Android, com foco em performance, experiência do usuário e integração com os sistemas do seu negócio.',
      whyYouNeed: 'Estar no celular do seu cliente aumenta engajamento, retenção e abre novos canais de receita.',
      image: programmingImage,
      icon: <Icons.Mobile />,
      color: 'from-sky-500 via-blue-600 to-indigo-600',
      accentColor: '#0ea5e9',
      features: ['iOS & Android', 'React Native', 'UX/UI', 'APIs'],
      duration: '2-5 meses',
      category: 'Mobile'
    },
    {
      id: 4,
      title: 'Criação de Dashboards',
      shortDesc: 'Visualize seus KPIs em tempo real',
      description: 'Desenvolvemos dashboards para visualização de dados.',
      longDescription: 'Desenvolvemos dashboards que facilitam a visualização de dados em tempo real para que você possa tomar decisões com base em dados precisos.',
      whyYouNeed: 'Tomar decisões com base em dados precisos e atuais.',
      image: dashboardImage,
      icon: <Icons.ChartBar />,
      color: 'from-orange-600 via-amber-600 to-yellow-600',
      accentColor: '#ff9800',
      features: ['Tempo Real', 'KPIs', 'Relatórios', 'Insights'],
      duration: '2-6 semanas',
      category: 'Analytics'
    },
    {
      id: 5,
      title: 'Automação de Processos',
      shortDesc: 'Otimize fluxos de trabalho',
      description: 'Automatizamos processos para melhorar eficiência.',
      longDescription: 'Automatizamos processos para melhorar a eficiência da sua empresa, ajudando a reduzir custos operacionais e melhorar a produtividade.',
      whyYouNeed: 'Automação ajuda a reduzir custos operacionais.',
      image: automationImage,
      icon: <Icons.Cogs />,
      color: 'from-emerald-600 via-green-600 to-teal-600',
      accentColor: '#4caf50',
      features: ['Workflows', 'Bots', 'Integração', 'Eficiência'],
      duration: '1-8 semanas',
      category: 'Automação'
    },
    {
      id: 6,
      title: 'Criação de Landing Pages',
      shortDesc: 'Páginas otimizadas para conversão',
      description: 'Criamos landing pages otimizadas.',
      longDescription: 'Criamos landing pages altamente otimizadas para maximizar a taxa de conversão, utilizando as melhores práticas de SEO e design persuasivo.',
      whyYouNeed: 'Uma landing page bem otimizada é crucial para marketing.',
      image: landingPageImage,
      icon: <Icons.FileAlt />,
      color: 'from-violet-600 via-purple-600 to-indigo-600',
      accentColor: '#9c27b0',
      features: ['Conversão', 'SEO', 'Design', 'A/B Testing'],
      duration: '1-2 semanas',
      category: 'Web Design'
    }
  ];

  const handleServiceSelect = (service: Service) => {
    setSelectedService(service);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setSelectedService(null);
    setShowForm(false);
    setFormData({ name: '', email: '', phone: '', company: '', message: '' });
    document.body.style.overflow = 'unset';
  };

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  const handleShowForm = () => {
    setShowForm(true);
  };

  const handleFormChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleWhatsAppSubmit = () => {
    const service = selectedService?.title || 'Serviço';
    const message = `🚀 *INTERESSE EM ${service.toUpperCase()}*\n\n` +
      `👤 *Nome:* ${formData.name}\n` +
      `📧 *Email:* ${formData.email}\n` +
      `📱 *Telefone:* ${formData.phone}\n` +
      `🏢 *Empresa:* ${formData.company || 'Não informado'}\n\n` +
      `💬 *Mensagem:*\n${formData.message || 'Gostaria de saber mais sobre este serviço.'}\n\n`;

    const whatsappUrl = `https://wa.me/5521936185311?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
    closeModal();
  };

  useEffect(() => {
    const handleEscapeKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && selectedService) {
        closeModal();
      }
    };

    document.addEventListener('keydown', handleEscapeKey);

    return () => {
      document.body.style.overflow = 'unset';
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [selectedService]);

  return (
    <div className="services-section">
      {/* Hero */}
      <div className="services-hero">
        <div className="services-container">
          <span className="services-badge">🚀 Nossas Soluções</span>
          <h1 className="services-title">Do Código ao Crescimento</h1>
          <p className="services-subtitle">
            Escolha a solução perfeita para impulsionar seu negócio. 
            <span className="services-accent"> Cada serviço é desenhado para gerar resultados reais.</span>
          </p>
        </div>
      </div>

      {/* Carousel */}
      <div className="services-carousel">
        <div className="services-container">
          <div className="carousel-header">
            <h2 className="carousel-title">⭐ MAIS POPULAR</h2>
          </div>

          <div className="popular-grid">
            {servicesData.filter(s => s.category === 'Automação' || s.category === 'Integração').map((service) => (
              <div key={service.id} className="service-card popular-card" onClick={() => handleServiceSelect(service)}>
                <div className={`card-image bg-gradient-to-br ${service.color}`}>
                  <div className="card-category">{service.category}</div>
                  <div className="card-icon">{service.icon}</div>
                </div>
                <div className="card-content">
                  <h3 className="card-title">{service.title}</h3>
                  <p className="card-description">{service.shortDesc}</p>
                  <div className="card-meta">
                    <div className="card-features">
                      {service.features.slice(0, 2).map((feature, index) => (
                        <span key={index} className="feature-tag">{feature}</span>
                      ))}
                    </div>
                    <span className="card-duration">{service.duration}</span>
                  </div>
                  <div className="card-progress">
                    <div className="progress-fill" style={{ width: '85%', background: `linear-gradient(90deg, ${service.accentColor}, ${service.accentColor}aa)` }}></div>
                  </div>
                  <span className="card-rating">⭐ 98% satisfação</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Grid */}

      <div className="services-grid">
        <div className="services-container">
          <h2 className="grid-title">Catálogo Completo</h2>
          <div className="grid-layout">
            {servicesData.map((service) => (
              <div key={service.id} className="grid-item" onClick={() => handleServiceSelect(service)}>
                <div className="grid-icon" style={{ backgroundColor: service.accentColor + '20', border: `1px solid ${service.accentColor}40` }}>
                  <div style={{ color: service.accentColor }}>{service.icon}</div>
                </div>
                <div className="grid-content">
                  <h3 className="grid-item-title">{service.title}</h3>
                  <p className="grid-item-desc">{service.shortDesc}</p>
                  <div className="grid-features">
                    {service.features.map((feature, index) => (
                      <span key={index} className="feature-tag">{feature}</span>
                    ))}
                  </div>
                  <div className="grid-meta">
                    <span className="meta-duration">{service.duration}</span>
                    <span className="meta-category">{service.category}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Modal */}
      {selectedService && (
        <div className="modal" onClick={handleBackdropClick}>
          <div
            className="modal-content"
            role="dialog"
            aria-modal="true"
            aria-label={selectedService.title}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={`modal-header bg-gradient-to-br ${selectedService.color}`}>
              <button onClick={closeModal} className="modal-close" aria-label="Fechar">×</button>
              <div className="modal-hero-icon">{selectedService.icon}</div>
              <h2 className="modal-title">{selectedService.title}</h2>
              <p className="modal-category">{selectedService.category}</p>
            </div>
            
            <div className="modal-body">
              {!showForm ? (
                <>
                  <div className="modal-section">
                    <h3>O que é?</h3>
                    <p>{selectedService.longDescription}</p>
                    
                    <h4>Por que você precisa?</h4>
                    <p>{selectedService.whyYouNeed}</p>

                    <h4>O que está incluído:</h4>
                    <div className="feature-list">
                      {selectedService.features.map((feature, index) => (
                        <div key={index} className="feature-item">
                          <div className="feature-dot" style={{ backgroundColor: selectedService.accentColor }}></div>
                          <span>{feature}</span>
                        </div>
                      ))}
                    </div>

                    <div className="info-box">
                      <div className="info-row">
                        <span>Prazo estimado:</span>
                        <span className="info-value">{selectedService.duration}</span>
                      </div>
                      <div className="info-row">
                        <span>Satisfação:</span>
                        <span className="info-value">⭐ 98%</span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="modal-actions">
                    <button onClick={closeModal} className="btn btn-competitor">
                      Agora não
                    </button>
                    <button onClick={handleShowForm} className="btn btn-primary">
                      🚀 Quero uma proposta
                    </button>
                  </div>
                </>
              ) : (
                <div className="form-container">
                  <h3 className="form-title">Vamos conversar sobre {selectedService.title}!</h3>
                  <p className="form-subtitle">Preencha seus dados.</p>
                  
                  <div className="form-wrapper">
                    <div className="form-row">
                      <input type="text" name="name" placeholder="Seu nome *" value={formData.name} onChange={handleFormChange} className="form-input" required />
                      <input type="email" name="email" placeholder="Seu e-mail *" value={formData.email} onChange={handleFormChange} className="form-input" required />
                    </div>
                    
                    <div className="form-row">
                      <input type="tel" name="phone" placeholder="Seu telefone *" value={formData.phone} onChange={handleFormChange} className="form-input" required />
                      <input type="text" name="company" placeholder="Sua empresa" value={formData.company} onChange={handleFormChange} className="form-input" />
                    </div>
                    
                    <textarea name="message" placeholder="Conte sobre seu projeto..." value={formData.message} onChange={handleFormChange} className="form-textarea" rows={3} />
                    
                    <div className="form-actions">
                      <button type="button" onClick={handleWhatsAppSubmit} disabled={!formData.name || !formData.email || !formData.phone} className="btn btn-primary">
                        💬 Enviar WhatsApp
                      </button>
                      <button type="button" onClick={() => setShowForm(false)} className="btn btn-secondary">
                        ← Voltar
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Services;